import { AXIOS_INSTANCE } from '.';
import { BASE_URL_BANKING } from '../utils/constants';

const isSuccess = (res) => {
  if (!res) return false;
  if (res?.statusCode === 200 || res?.statusCode === 201) return true;
  if (res?.code === 200 || res?.code === 201) return true;
  if (res?.status === 200 || res?.status === 201) return true;
  if (res?.success === true) return true;
  return false;
};

const extractData = (res) => {
  if (!res) return null;
  if (res?.data !== undefined) return res.data;
  if (res?.response !== undefined && typeof res.response !== 'string') return res.response;
  return res;
};

export const getWithdrawalRequests = async (status) => {
  try {
    const params = status ? `?status=${status}` : '';
    const result = await AXIOS_INSTANCE.get(
      `${BASE_URL_BANKING}/admin/withdrawal-requests${params}`
    );
    return result?.data ?? result?.response?.data ?? null;
  } catch (error) {
    return { status: 'Error', code: 500, message: error.message };
  }
};

export const processWithdrawalRequest = async (payload) => {
  try {
    const result = await AXIOS_INSTANCE.post(
      `${BASE_URL_BANKING}/admin/withdrawal-requests/process`,
      payload
    );
    return result?.data ?? result?.response?.data ?? null;
  } catch (error) {
    return { status: 'Error', code: 500, message: error.message };
  }
};

export { isSuccess, extractData };
